import { Space } from 'antd';
import PropTypes from 'prop-types';
import styles from './PageTitle.module.scss';

const PageTitle = ({ title = "Silos", subTitle, children }) => {
    return (
        <div className={styles.pageHeader}>
            <div className={styles.titleBlock}>
                <h1 className={styles.pageTitle}>{title}</h1>
                {subTitle && <p className={styles.subTitle}>{subTitle}</p>}
            </div>
            {children && (
                <div className={styles.actions}>
                    <Space size={[6, 4]} wrap>{children}</Space>
                </div>
            )}
        </div>
    );
};

PageTitle.propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    children: PropTypes.node,
};

export default PageTitle;
